module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.errors) ? _c('div', {
    staticClass: "app-body app flex-row align-items-center"
  }, [_c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v("\n              Произошла непредвиденная ошибка, попробуйте обновить страницу.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.errors) + "\n            ")])])])])])]) : [_c('router-view'), _vm._v(" "), _c('toast', {
    attrs: {
      "html": true,
      "position": "se"
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-25441132"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1012
// module chunks = 1